import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import TextField from '@material-ui/core/TextField'
import * as utils from '@utils'
import { PfSubPfSelect, GameSelect, DateSelect, CompleteDecimal } from '@select'
import { API, DATE } from '@const'
import { Grid, Divider, Select, MenuItem, FormControl, InputLabel, Button } from '@material-ui/core'
import { Search, SaveAlt } from '@material-ui/icons'
import { UserActionLogDialog, ComponentDialog } from '@dialogs'
import { Decimal } from 'decimal.js'
import ExcelJs from "exceljs/dist/exceljs";

import { Table } from 'antd'

export const SEARCH_TYPE_DATE = 'date',
    SEARCH_TYPE_BET_SLIP = 'betSlip',
    SEARCH_TYPE_ROUND = 'round'

class GameRoundResultPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'GameRoundResultPage', options)
        }
        this.handleTableChange = this.handleTableChange.bind(this)
    }

    state = {
        searchType: SEARCH_TYPE_DATE,
        betRecordID: '',
        roundID: '',
        currency: '',
        list: [],
        dataLength: 0,
        loading: false,
        currentPage: 1,
        pageLimit: 10,
        total: 0,
        pageSizeOptions: ['10','30','50','100']
    }

    columns = [
        {
            title: utils.t('round_end_at', 'GameRoundResultPage'),
            dataIndex: 'round_end_at',
            align: 'center',
            render: (text) => {
                return utils.unixToDateTime(text)
            },
            sorter: true
        },
        {
            title: utils.t('bet_record_id', 'GameRoundResultPage'),
            dataIndex: 'bet_record_id',
            align: 'center',
            render: (text, record) => {
                return (
                    <a
                        href="/#"
                        onClick={(e) => {
                            e.preventDefault()
                            this.setState({ loading: true })
                            utils.apiRequest(
                                'get',
                                API.BET_DETAIL + '/' + record.bet_record_id,
                                {
                                    lang: utils.getCurrentLang(),
                                },
                                (data) => {
                                    const currency = utils.getPfSubPfCurrency(record['pf_sub_pf_id'])
                                    const query = `&timezone=-0400&is_cms=yes&currency=${currency}&currency_rate=${1 /
                                        utils.getCurrencyRate(currency)}`

                                    window.open(data.url + query)
                                    this.setState({ loading: false })
                                },
                                (_error) => {
                                    this.setState({ loading: false })
                                }
                            )
                        }}>
                        {text}
                    </a>
                )
            },
            sorter: true
        },
        {
            title: utils.t('round_id', 'GameRoundResultPage'),
            dataIndex: 'round_id',
            align: 'center',
            render: (text, record) => {
                return text ? (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() =>
                            this.compDialog.OpenDialog(
                                this.t('GameRoundResultPage'),
                                <SelfComponent
                                    compDialogArgs={{
                                        searchType: SEARCH_TYPE_ROUND,
                                        roundID: record['round_id'],
                                    }}></SelfComponent>
                            )
                        }>
                        {text}
                    </Button>
                ) : ''
            },
            sorter: true
        },
        {
            title: utils.t('pf_sub_pf_id', 'GameRoundResultPage'),
            dataIndex: 'pf_sub_pf_id',
            align: 'center',
            render: (text) => {
                return text ? utils.GeneratePfSubPfName(text) : ''
            },
            
        },
        {
            title: utils.t('game_name', 'GameRoundResultPage'),
            dataIndex: 'game_code',
            align: 'center',
            render: (text) => {
                return text ? utils.t(`GameName.${text}`) : ''
            },
        },
        {
            title: utils.t('pf_account', 'GameRoundResultPage'),
            dataIndex: 'pf_account',
            align: 'center',
        },
        {
            title: utils.t('origin_account', 'GameRoundResultPage'),
            dataIndex: 'origin_account',
            align: 'center',
        },
        {
            title: utils.t('result', 'GameRoundResultPage'),
            dataIndex: 'bet_status',
            align: 'center',
            render: (text) => {
                if (text) {
                    const result = utils.t(`BetStatus.${text}`)
                    const fontColor = /輸|Lose|输/.test(result) ? 'red' : ''
                    return <div style={{ color: fontColor }}>{result}</div>
                }
                return '' 
            },
        },
        {
            title: utils.t('bet_area', 'GameRoundResultPage'),
            dataIndex: 'bet_area',
            align: 'center',
            width: 120,
            render: (text) => {
                return <div style={{whiteSpace: 'nowrap'}}>{text}</div>               
            }
        },
        {
            title: utils.t('bet', 'GameRoundResultPage'),
            dataIndex: 'bet',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''               
            },
            sorter: true
        },
        {
            title: utils.t('bet_valid', 'GameRoundResultPage'),
            dataIndex: 'bet_valid',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('profit', 'GameRoundResultPage'),
            dataIndex: 'profit',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    const fontColor = text < 0 ? 'red' : ''
                    return <div style={{ color: fontColor }}>{display}</div>
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('tax', 'GameRoundResultPage'),
            dataIndex: 'tax',
            align: 'center',
            render: (text) => {
                if (!isNaN(text)) {
                    const display = utils.currencyTrans(text, this.state.currency)
                    return display
                }
                return ''
            },
            sorter: true
        },
        {
            title: utils.t('common_result', 'GameRoundResultPage'),
            dataIndex: 'common_result',
            align: 'center',
            render: (text, record, index) => {
                /** 需另外處理開獎結果 */
                if (utils.IsSupportSplitBetRecord(record.game_code)) {
                    /** 已有開獎結果 */
                    if (record.roundResults) {
                        const commonResult = JSON.parse(record.roundResults)
                        return utils.GetBetTypeGameCommonResultDisplay(record.game_code, commonResult, true)
                    } else {
                    /** 未有開獎結果 */
                        return (
                            <a
                                href="/#"
                                onClick={(e) => {
                                    e.preventDefault()
                                    /** 使用api取得開獎結果 */
                                    utils.apiRequest('get', API.BET_RECORD_LIST + '/round_result/' + record.round_id, {}, (data) => {
                                        const newList = [...this.state.list]
                                        newList[index].roundResults = data.common_result
                                        /** 將開獎結果組入相對應資料後更新list觸發table刷新 */
                                        this.setState({list: newList})
                                    })
                                }}>
                                {this.t('showResults')}
                            </a>
                        )
                    }
                } else {
                    return ''
                }
            }
        },
        {
            title: utils.t('user_action_log', 'GameRoundResultPage'),
            align: 'center',
            render: (text, record) => {
                return utils.IsBetTypeGame(record.game_code) ? (
                    <Button
                        style={{ minWidth: '93px' }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.logDialog.OpenDialog({
                                game_code: record.game_code,
                                pf_account: record.pf_account,
                                round_id: record.round_id,
                                round_end_at: utils.datetimeToUnix(record.round_end_at),
                            })
                        }}>
                        {utils.t('view')}
                    </Button>
                ) : ''
            }
        },
        {
            title: utils.t('status'),
            align: 'center',
            dataIndex: 'purchase_method',
            render: (text) => {
                return Number(text) ? utils.t(`featureStatus.${text}`) : ''
            }
        },
    ]

    componentDidMount() {
        if (this.props.compDialogArgs) {
            const promiseList = []
            promiseList.push(
                new Promise((resolve) => {
                    const state = {
                        searchType: this.props.compDialogArgs.searchType,
                    }

                    switch (state.searchType) {
                        case SEARCH_TYPE_DATE:
                            state.pfAccount = this.props.compDialogArgs.pfAccount
                            break
                        case SEARCH_TYPE_BET_SLIP:
                            state.betRecordID = this.props.compDialogArgs.betRecordID
                            break
                        case SEARCH_TYPE_ROUND:
                            state.roundID = this.props.compDialogArgs.roundID
                            break
                        default:
                            return
                    }

                    this.setState(state, resolve)
                })
            )

            this.props.compDialogArgs.searchType === SEARCH_TYPE_DATE &&
                promiseList.push(
                    new Promise((resolve) => {
                        this.dateSelect.setState(
                            {
                                startDate: this.props.compDialogArgs.startDate,
                                endDate: this.props.compDialogArgs.endDate,
                            },
                            resolve
                        )
                    })
                )

            this.props.compDialogArgs.searchType === SEARCH_TYPE_DATE &&
                promiseList.push(
                    new Promise((resolve) => {
                        this.pfSelect.setState(
                            {
                                pfId: this.props.compDialogArgs.pfId,
                                pfSubPfId: this.props.compDialogArgs.pfSubPfId,
                            },
                            resolve
                        )
                    })
                )

            this.props.compDialogArgs.searchType === SEARCH_TYPE_DATE &&
                promiseList.push(
                    new Promise((resolve) => {
                        this.gameSelect.setState(
                            {
                                gameMaker: this.props.compDialogArgs.gameMaker ?? 'all',
                                displayGameTypeCode: this.props.compDialogArgs.displayGameTypeCode,
                                gameCode: this.props.compDialogArgs.gameCode || 'all',
                            },
                            resolve
                        )
                    })
                )

            Promise.all(promiseList).then(() => this.handleSearch())
        }
    }

    queryData() {
        let apiPath, queryParams
        const dateUnit = this.props?.compDialogArgs?.dateUnit ?? 'day'
        const start_date = this.props.compDialogArgs
            ? utils.datetimeToUnix_startOf(this.props.compDialogArgs.startDate, dateUnit)
            : utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, 'day')
        const end_date = this.props.compDialogArgs
            ? utils.datetimeToUnix_endOf(this.props.compDialogArgs.endDate, dateUnit)
            : utils.datetimeToUnix_endOf(this.dateSelect.state.endDate, 'day')
        switch (this.state.searchType) {
            case SEARCH_TYPE_DATE:
                apiPath = API.BET_RECORD_LIST
                queryParams = {
                    lang: utils.getCurrentLang(),
                    pf_id:this.pfSelect.state.pfId !== 'all' ?this.pfSelect.state.pfId : '',
                    pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
                    display_game_type_code_id: this.gameSelect.state.displayGameTypeCode !== 'all' ? this.gameSelect.state.displayGameTypeCode : '',
                    game_code: this.gameSelect.state.gameCode !== 'all' ? this.gameSelect.state.gameCode : '',
                    start_date,
                    end_date,
                    pf_account: this.state.pfAccount,
                    timezone: DATE.CLIENT_UTC_OFFSET,
                    purchase_method: 0
                }

                /** 開發商不是全部時需攜帶查詢參數 */
                if (this.gameSelect.state.gameMaker !== 'all') {
                    queryParams.maker = String(this.gameSelect.state.gameMaker)
                }

                // 僅查詢買免費項目
                if (this.props.compDialogArgs?.purchase_method) {
                    queryParams.purchase_method = this.props.compDialogArgs?.purchase_method
                }

                break

            case SEARCH_TYPE_BET_SLIP:
                apiPath = API.BET_RECORD
                queryParams = {
                    bet_record_id: this.state.betRecordID,
                }
                break
            case SEARCH_TYPE_ROUND:
                apiPath = API.BET_RECORD_LIST_BY_ROUND_ID
                queryParams = {
                    round_id: this.state.roundID,
                }
                break
            default:
                return
        }
        queryParams = {
            ...queryParams,
            page: this.state.currentPage,
            limit: this.state.pageLimit
        }

        if (this.state.sort_field !== '' && this.state.sort_order !== '') {
            const sortParams = {
                "ascend": 'ASC',
                "descend": 'DESC'
            }
            queryParams.sort_field = this.state.sort_field
            queryParams.sort_order = sortParams[this.state.sort_order]

            // 特規處理區
            if (this.state.sort_field === 'bet_record_id') { 
                queryParams.sort_field = 'record_id'
            }
        }

        /** 沒有開發商權限時移除 */
        if (!utils.checkValid('report.maker')) {
            delete queryParams['maker']
        }
        this.setState({ loading: true })
        utils.apiRequest(
            'get',
            apiPath,
            queryParams,
            ({data, page}) => {
                let pf_id = ''
                if (queryParams['pf_id']) {
                    pf_id = queryParams['pf_id']
                } else if (queryParams['pf_sub_pf_id']) {
                    pf_id = String(queryParams.pf_sub_pf_id).split('_')[0]
                }
                let currency = utils.getPfCurrency(pf_id)
                const betRecordList = []
                
                switch (this.state.searchType) {
                    case SEARCH_TYPE_DATE:
                        betRecordList.push(...data['bet_record_list'])
                        break
                    case SEARCH_TYPE_BET_SLIP:
                        currency = utils.getPfCurrency(data['pf_id'])
                        betRecordList.push(data)
                        break
                    case SEARCH_TYPE_ROUND:
                        if (data && 0 < data.length) {
                            currency = utils.getPfCurrency(data[0].pf_id)
                        }
                        betRecordList.push(...data)
                        break
                    default:
                        return
                }
                // Split bet area type game
                const parsedData = []
                // 直接輸出相對應結果
                const gameCodeList = ['GarudaGod', 'AviatorX', 'Aviator']
                betRecordList.forEach((elem) => {
                    const temp = []
                    if (utils.IsSupportSplitBetRecord(elem.game_code)) {
                        const result = JSON.parse(elem.result)

                        if (elem.game_code === 'ColorPlate' && !result['area_profit']) {
                            temp.push(elem)
                        } else if (gameCodeList.includes(elem.game_code)) {
                            elem.roundResults = elem.result
                            const detail = {
                                ...elem
                            }
                            const betArea = JSON.parse(elem.result).OddsFlyout.reduce((all, cur)=>{
                                if (cur.has_bet) {
                                    if (cur?.is_extra_bet) {
                                        all.push(`${cur.odds_flyout}x (★${cur.extra_multiplier}x)`)
                                    } else {
                                        all.push(`${cur.odds_flyout}x`)
                                    }
                                } else {
                                    all.push('0x')
                                }
                                return all
                            }, [])
                            detail.bet_area = betArea.join(' - ')
                            temp.push(detail)
                        } else {
                            const parents = {
                                ...elem,
                                children: []
                            }
                            result['bet_status'].forEach((value, idx) => {
                                const profit = result['per_area_profit'] ? result['per_area_profit'][idx] : result['area_profit'][idx]
                                if (value > 0) {
                                    let isPeace = false
                                    if (elem.game_code === 'ShaiZiSanGong' || elem.game_code === 'DragonTiger') {
                                        isPeace = Number(new Decimal(value).add(new Decimal(profit).mul(2))) === 0
                                    } else {
                                        isPeace = profit === 0
                                    }
                                    const detail = {
                                        bet: value,
                                        bet_valid: isPeace ? utils.handleBetValid(elem.game_code, value, profit) : value,
                                        profit: profit,
                                        bet_area: utils.GetBetTypeGameAreaDisplay(elem.game_code, idx),
                                        bet_status: isPeace ? 3 : profit > 0 ? 1 : 2, // "1": "赢", "2": "输", "3": "和"
                                        id: `${elem.bet_record_id}-child-${idx}`
                                    }
                                    /** 注單結果 */
                                    if (Number(elem.bet_status) === 5 || Number(elem.bet_status) === 4) {
                                        detail.bet_status = elem.bet_status 
                                        detail.bet_valid = 0
                                        detail.profit = 0
                                        detail.operator_profit = 0
                                    }
                                    if (elem.game_code === 'ColorGame' && result['jackpot_info'] && detail.profit > 0) {
                                        /** ColorGame 壓中 Bonus */
                                        detail.profit = new Decimal(profit).add(result['jackpot_info'].money)
                                    }
                                    parents.children.push(detail)
                                }
                            })
                            if (elem.game_code === 'CyberpunkColorDisc' && result.jackpot_info && Number(result.jackpot_info?.money) > 0) {
                                const jackpot_info = {
                                    bet: '',
                                    bet_valid: '',
                                    profit: result['jackpot_info'].money,
                                    bet_area: `JACKPOT(${utils.GetBetTypeGameAreaDisplay(elem.game_code, Number(result['jackpot_area']) + 6)})`,
                                    bet_status: 1,
                                    id: `${elem.bet_record_id}-child-JACKPOT_PAYOUT`
                                }
                                parents.children.push(jackpot_info)
                            }
                            delete parents.bet_status
                            temp.push(parents)
                        }
                    } else {
                        temp.push(elem)
                    }

                    parsedData.push(...temp)
                })
                
                parsedData.forEach((item, index) => {
                    item.id = `${index*this.state.currentPage}--${item.round_id}`

                })
                
                this.setState({
                    list: parsedData,
                    dataLength: page.count,
                    loading: false,
                    currency
                })
            },
            (_err) => {
                console.log('_err', _err)
                this.setState({
                    list: [],
                    dataLength: 0,
                    loading: false
                })
            },
            true
        )
    }
    /** submit */
    handleSearch() {
        this.setState({
            currentPage: 1
        }, () => {
            this.queryData()
            utils.goTop()
        })
        
    }
    /** change page / limit */
    handlePageChange(page, limit) {
        this.setState({
            currentPage: page,
            pageLimit: limit
        }, () => {
            this.queryData()
            utils.goTop()
        })
    }

    handleTableChange(pagination, _filters, sorter) {
        const sort = (field, order) => {
            this.setState({
                sort_field: field,
                sort_order: order,
                pageLimit: pagination.pageSize
            })
        }
        sorter.order ? sort(sorter.field, sorter.order) : sort('', '')
    }

    handleExport() {
        const originData = JSON.parse(JSON.stringify(this.state.list))
        const columns = JSON.parse(JSON.stringify(this.columns)).filter((item) => (item.dataIndex && item.dataIndex !== 'common_result'))

        /** 將資料依照順序轉成陣列化 */
        const createData = (data) => {
            const prevData = columns.reduce((acc, currColumns) => {
                const text = data?.[currColumns.dataIndex]
                let value = ''
                if (currColumns.dataIndex === 'round_end_at') {
                    value = utils.unixToDateTime(text)
                } else if (currColumns.dataIndex === 'pf_sub_pf_id') {
                    value = text ? utils.GeneratePfSubPfName(text) : ''
                } else if (currColumns.dataIndex === 'game_code') {
                    value = text ? utils.t(`GameName.${text}`) : ''
                } else if (currColumns.dataIndex === 'bet_status') {
                    value = text ? utils.t(`BetStatus.${text}`) : ''
                } else if (['bet', 'bet_valid', 'profit', 'tax'].includes(currColumns.dataIndex)) {
                    value = utils.currencyTrans(text, this.state.currency)
                } else if (currColumns.dataIndex === 'purchase_method') {
                    value = Number(text) ? utils.t(`featureStatus.${text}`) : ''
                } else {
                    value = !isNaN(text) || text ? text : ''
                }
                acc.push(value)
                return acc
            }, [])
            return prevData
        }
        /** 建立每筆資料 */
        const excelBody = originData.reduce((accumulator, currentValue)=>{
            const item = createData(currentValue)
            accumulator = [...accumulator, item]
            if (currentValue.children && currentValue.children.length) {
                currentValue.children.forEach(data => {
                    const childItem = createData(data)
                    accumulator = [...accumulator, childItem]
                })
            }
            return accumulator
        }, [])

        
        const workbook = new ExcelJs.Workbook();
        const sheet = workbook.addWorksheet(this.t('Title'));

        sheet.addTable({
            name: this.t('Title'), 
            ref: 'A1',
            columns: columns.map(item => {return {'name': item.title}}),
            rows: excelBody
        })

        sheet.eachRow((row) => {
            row.font = { size: 12 }; // 將字體設為 12 
        });

        columns.forEach((_column, index)=>{
            if (index < 7) {
                sheet.getColumn(index+1).width = 28
            } else if (index === 7) {
                sheet.getColumn(index+1).width = 8
            } else {
                sheet.getColumn(index+1).width = 15
            }

            if (index > 8 && index < 13) {
                sheet.getColumn(index+1).alignment = { horizontal: 'right' };
            }
        });
    
        workbook.xlsx.writeBuffer().then((content) => {
            const link = document.createElement("a");
            const blobData = new Blob([content], {
                type: "application/vnd.ms-excel;charset=utf-8;"
            });
            link.download = `${this.t('Title')}.xlsx`;
            link.href = URL.createObjectURL(blobData);
            link.click();
        })
    }

    render() {
        return (
            <React.Fragment>
                <Grid container spacing={2} className={this.props.compDialogArgs ? this.props.classes.hide : ''}>
                    <Grid item xs={12} className={this.props.classes.alignCenter}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel htmlFor="age-simple">{this.t('searchType')}</InputLabel>
                            <Select
                                value={this.state.searchType}
                                onChange={(event) =>
                                    this.setState({
                                        searchType: event.target.value,
                                    })
                                }>
                                <MenuItem value={SEARCH_TYPE_DATE}>{this.t('date')}</MenuItem>
                                <MenuItem value={SEARCH_TYPE_BET_SLIP}>{this.t('betSlipNo')}</MenuItem>
                                <MenuItem value={SEARCH_TYPE_ROUND}>{this.t('roundId')}</MenuItem>
                            </Select>
                        </FormControl>
                        <DateSelect
                            options={{ hide: this.state.searchType !== SEARCH_TYPE_DATE }}
                            onRef={(ref) => (this.dateSelect = ref)}
                            >
                        </DateSelect>
                        {this.state.searchType === SEARCH_TYPE_DATE && (
                            <React.Fragment>
                                <GameSelect 
                                    onRef={(ref) => (this.gameSelect = ref)}
                                    options={{gameMakerSelect: utils.checkValid('report.maker')}}
                                >
                                </GameSelect>
                                <PfSubPfSelect onRef={(ref) => (this.pfSelect = ref)} options={{hideAllPlatform: true}}></PfSubPfSelect>
                            </React.Fragment>
                        )}
                        <TextField
                            label={this.t('betSlipNo')}
                            placeholder={this.t('enterNoEntirely')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.betRecordID}
                            onChange={(event) =>
                                this.setState({
                                    betRecordID: event.target.value,
                                })
                            }
                            className={this.state.searchType !== 'betSlip' ? this.props.classes.hide : this.props.classes.textField}
                        />
                        <TextField
                            label={this.t('roundId')}
                            placeholder={this.t('enterNoEntirely')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            value={this.state.roundID}
                            onChange={(event) =>
                                this.setState({
                                    roundID: event.target.value,
                                })
                            }
                            className={this.state.searchType !== 'round' ? this.props.classes.hide : this.props.classes.textField}
                        />
                        <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.handleSearch()}>
                            <Search className={this.props.classes.rightIcon} />
                            {this.t('search')}
                        </Button>
                        <Grid item>
                            <CompleteDecimal />
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid
                    container spacing={2}
                >
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <Button variant="contained" color="primary" className={this.props.classes.button} disabled={!this.state.list.length} onClick={() => this.handleExport()}>
                            <SaveAlt className={this.props.classes.exportIcon} />
                            {utils.t('export')}
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <Table
                            onRef={(ref) => (this.table = ref)}
                            className="game-round-result-table"
                            size="small"
                            loading={this.state.loading}
                            columns={this.columns}
                            dataSource={this.state.list}
                            bordered
                            rowKey="id"
                            locale={{
                                emptyText: utils.t('noRecordsToDisplay', 'Table')
                            }}
                            pagination={{
                                current: this.state.currentPage,
                                pageSize: this.state.pageLimit,
                                total: this.state.dataLength,
                                showTotal: () => ``,
                                onChange: (nextPage, currentPageSize) => {
                                    this.handlePageChange(nextPage, currentPageSize)
                                },
                                onShowSizeChange: (currentPage, nextSize) => {
                                    this.handlePageChange(1, nextSize)
                                },
                                showSizeChanger: true, // 允许改变每页显示的条数
                                pageSizeOptions: this.state.pageSizeOptions, // 每页显示的条数选项
                            }}
                            onChange={this.handleTableChange} // 排序 篩選 資料變更 都會觸發這裡 目前用來 call 排序 api
                        />
                        <UserActionLogDialog
                            onRef={(ref) => (this.logDialog = ref)}
                            currencyRate={
                                this.props.dataService.exchangeCurrencyMap && this.props.dataService.exchangeCurrencyMap[this.state.currency]
                                    ? 1 / this.props.dataService.exchangeCurrencyMap[this.state.currency].rate
                                    : 1
                            }></UserActionLogDialog>
                        <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
                    </Grid>
                </Grid>
            </React.Fragment>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '210px',
        },
        button: {
            margin: theme.spacing(1),
            padding: '6px 10px',
            minWidth: 85
        },
        rightIcon: {
            marginRight: '0px',
        },
        exportIcon: {
            paddingRight: '5px'
        },
        show: {
            display: 'block'
        },
        hide: {
            display: 'none',
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
    }
}

GameRoundResultPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
    compDialogArgs: PropTypes.object,
}

const SelfComponent = hoc(styles)(GameRoundResultPage)
export default SelfComponent
